export class StatusProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "statusMessageKey",
            "baseName": "statusMessageKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "statusMessage",
            "baseName": "statusMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StatusProperties.attributeTypeMap;
    }
    constructor() {
    }
}
